'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleListController = function () {
  function VehicleListController(authService, vehicleService, loadingService, lookupService, enums, $q, $window, appConfig, $stateParams, printService, fileService) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, VehicleListController);
    if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View)) {
      return;
    }

    this.authService = authService;
    this.vehicleService = vehicleService;
    this.loadingService = loadingService;
    this.lookupService = lookupService;
    this.enums = enums;
    this.$q = $q;
    this.$window = $window;
    this.appConfig = appConfig;
    this.$stateParams = $stateParams;
    this.printService = printService;
    this.fileService = fileService;

    this.filterParams = {};

    this.initializeEnumLookups().then(function () {
      _this.reset();
    });
  }

  (0, _createClass3.default)(VehicleListController, [{
    key: 'initializeLookups',
    value: function initializeLookups() {
      var _this2 = this;

      var ctrl = this;
      var deferred = ctrl.$q.defer();

      this.lookupService.lookupBrands().then(function (brands) {
        //If New Vehicle then filter brands with only allowed brands on roles in this location
        if (ctrl.filterParams.vehicleConditionSearch.id === 1) {
          var allowedBrands = ctrl.authService.getLocationBrands(ctrl.enums.PERMISSION_TYPE.View);
          var hasAllBrand = (0, _lodash.find)(allowedBrands, function (brandId) {
            return brandId === 1;
          });

          if (hasAllBrand) {
            brands[0].name = 'All Brands';
            _this2.brands = brands;
          } else {
            _this2.brands = (0, _lodash.filter)(brands, function (o) {
              return (0, _lodash.find)(allowedBrands, function (brandId) {
                return brandId === o.brandId;
              }) !== undefined;
            });

            //Add this specific list in filterParams so it can be used to send it to server
            ctrl.filterParams.allowedBrands = _this2.brands;

            //Add a special 0 brandId which will be used to filter only on the allowed brands
            _this2.brands = [{ brandId: 0, name: 'All Brands' }].concat((0, _toConsumableArray3.default)(_this2.brands));
          }
        } else {
          brands[0].name = 'All Brands';
          _this2.brands = brands;
        }

        _this2.filterParams.brand = _this2.brands[0];

        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
          _this2.allBrandModels = brandModels;
          _this2.updateBrandModel();
          deferred.resolve();
        });
      });

      return deferred.promise;
    }
  }, {
    key: 'updateBrandModel',
    value: function updateBrandModel() {
      var _this3 = this;

      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
        return o.brandId === _this3.filterParams.brand.brandId;
      });
      this.brandModels = [{ brandModelId: 0, name: 'All Models' }].concat((0, _toConsumableArray3.default)(this.brandModels));
      this.filterParams.brandModel = this.brandModels[0];
    }
  }, {
    key: 'initializeEnumLookups',
    value: function initializeEnumLookups() {
      var _this4 = this;

      var ctrl = this;
      var deferred = ctrl.$q.defer();
      var lookups = ['VehicleConditionSearch', 'VehicleStatus'];
      this.enumLookupCollection = [];

      this.lookupService.lookupEnums(lookups).then(function (enumLookupCollection) {
        if (enumLookupCollection.vehicleStatus) {
          enumLookupCollection['vehicleStatus'] = enumLookupCollection['vehicleStatus'].slice(0, 3);
          enumLookupCollection['vehicleStatus'].unshift({ id: null, name: 'All States' });
        }

        _this4.enumLookupCollection = enumLookupCollection;

        (0, _lodash.map)(enumLookupCollection, function (itemsArray, index) {
          _this4.filterParams[index] = itemsArray[0];
        });

        _this4.initializeLookups().then(function () {
          _this4.initializeMyLocations().then(function () {
            return deferred.resolve();
          });
        });
      });

      return deferred.promise;
    }
  }, {
    key: 'initializeMyLocations',
    value: function initializeMyLocations() {
      var _this5 = this;

      var promise = this.lookupService.lookupMyLocations(this.authService.authData.currentLocation.key);

      promise.then(function (response) {
        _this5.myLocations = response.data;
      });

      return promise;
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this6 = this;

      var ctrl = this;

      if (ctrl.$stateParams.vehicleConditionSearch) {
        /*
        * This check is added to select a Vehicle Condition (New, Used Retail or Used Trade)
        * After coming back from Add / Edit vehicle
        */
        ctrl.filterParams.vehicleConditionSearch = (0, _lodash.find)(ctrl.enumLookupCollection.vehicleConditionSearch, function (o) {
          return o.id === ctrl.$stateParams.vehicleConditionSearch;
        });
        ctrl.$stateParams.vehicleConditionSearch = null;
      } else {
        //Set Condition to New
        this.filterParams.vehicleConditionSearch = this.enumLookupCollection.vehicleConditionSearch[0];
      }

      this.filterParams.vehicleStatus = this.enumLookupCollection.vehicleStatus[0];
      this.filterParams.registration = null;

      var promise = this.initializeLookups();

      promise.then(function () {
        _this6.pagination = {
          totalItems: 0,
          currentPage: 1,
          pageSize: ctrl.publishMode ? -1 : 10
        };

        _this6.filterParams.entityId = _this6.authService.authData.currentLocation.key;
        _this6.filterParams.pageCriteria = {
          pageStart: 0,
          itemsToFetch: _this6.pagination.pageSize,
          sortExpression: 'condition',
          ascending: true
        };

        _this6.notification = {
          type: 'info',
          msg: ''
        };

        _this6.listVehicles();
      });
    }
  }, {
    key: 'updatePageIndex',
    value: function updatePageIndex() {
      if (this.pagination.currentPage === 1) {
        this.filterParams.pageCriteria.pageStart = 0;
      } else {
        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      }
    }
  }, {
    key: 'updateSort',
    value: function updateSort(fieldName) {
      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
      } else {
        this.filterParams.pageCriteria.sortExpression = fieldName;
        this.filterParams.pageCriteria.ascending = true;
      }

      this.listVehicles();
    }
  }, {
    key: 'listVehicles',
    value: function listVehicles() {
      var ctrl = this;

      ctrl.updatePageIndex();

      ctrl.loadingService.showLoading('vehicleListing', 'Loading Vehicles ...');

      ctrl.vehicleService.listVehicles(ctrl.filterParams).then(function (response) {
        //response.data.items.map(entity => listCtrl.getActionsDropdown(entity));
        ctrl.vehicles = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: 'No data to display'
          };
        } else {
          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' vehicles'
          };
        }
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('vehicleListing');
      });
    }
  }, {
    key: 'deleteVehicle',
    value: function deleteVehicle(vehicleId) {
      var _this7 = this;

      var ctrl = this;
      var sure = void 0,
          state = void 0;

      sure = this.$window.confirm('Are you sure you want to delete this vehicle ?');

      if (!sure) {
        return;
      }

      this.loadingService.showLoading('vehicleListing', 'Removing Vehicle ...');

      ctrl.vehicleService.updateVehicleState(this.authService.authData.currentLocation.key, vehicleId, this.enums.VEHICLE_STATUS.Discontinued).then(function (response) {
        ctrl.listVehicles();
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while updating vehicle state. " + err.data.messageDetail ? err.data : err.data.messageDetail
        };
      }).finally(function () {
        _this7.loadingService.hideLoading('vehicleListing');
      });
    }
  }, {
    key: 'selectAllVehicles',
    value: function selectAllVehicles() {
      var ctrl = this;

      ctrl.vehicles.map(function (v) {
        v.publishToWeb = ctrl.allVehicles;
      });
    }
  }, {
    key: 'publishVehicles',
    value: function publishVehicles() {
      var ctrl = this;

      ctrl.fileService.exportVehicles(ctrl.authService.authData.currentLocation.key);
    }
  }, {
    key: 'viewPublishedFiled',
    value: function viewPublishedFiled() {
      var fileName = this.publishFileName.split('.')[0];
      var fileExt = this.publishFileName.split('.')[1];
      window.location = this.appConfig.apiServiceBaseUri + 'api/file/getfile/' + fileName + '/' + fileExt;
      //alert(this.publishFileName);
    }
  }, {
    key: 'print',
    value: function print() {
      var queryParams = this.vehicleService.getQueryParams(this.filterParams);

      this.printService.printVehicleList(queryParams);
    }
  }]);
  return VehicleListController;
}();

exports.default = VehicleListController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleList/vehicleList.controller.js